module.exports = "#podpowitanie{\r\n    letter-spacing: 3px;\r\n    padding: 30px;\r\n    width:33%;\r\n    left:33%;\r\n    position:absolute;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/main.component.css
// module id = ./src/app/main/main.component.css
// module chunks = main